import React, { useState } from 'react';
import { mockSubmissions } from '../data/mockData';
import { StatusBadge } from '../components/StatusBadge';
import { WorkflowProgress } from '../components/WorkflowProgress';
import { ShieldCheck, FileText, CheckCircle, XCircle, Download } from 'lucide-react';
export const AdminApprovalScreen: React.FC = () => {
  const [selectedSub, setSelectedSub] = useState(mockSubmissions.find(s => s.status === 'ready_for_approval') || null);
  const [activeTab, setActiveTab] = useState<'summary' | 'khatians' | 'documents'>('summary');
  const readySubmissions = mockSubmissions.filter(s => s.status === 'ready_for_approval');
  if (!selectedSub) {
    return <div className="max-w-6xl mx-auto text-center py-20" data-id="element-217">
        <ShieldCheck size={64} className="mx-auto text-slate-300 mb-4" data-id="element-218" />
        <h2 className="text-xl font-semibold text-slate-700" data-id="element-219">
          কোন অপেক্ষমাণ অনুমোদন নেই
        </h2>
        <p className="text-slate-500" data-id="element-220">
          সমস্ত প্রক্রিয়াকৃত ডেটা যাচাই এবং প্রকাশ করা হয়েছে।
        </p>
      </div>;
  }
  return <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6" data-id="element-221">
      {/* Sidebar List */}
      <div className="w-full lg:w-1/3 flex flex-col gap-4" data-id="element-222">
        <div className="mb-2" data-id="element-223">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-224">
            চূড়ান্ত যাচাইকরণ
          </h1>
          <p className="text-sm text-slate-500" data-id="element-225">
            পর্যালোচনা এবং ডিএলএমএস-এ প্রকাশ করুন
          </p>
        </div>

        <div className="card overflow-hidden flex-1" data-id="element-226">
          <div className="bg-slate-50 px-4 py-3 border-b border-slate-200" data-id="element-227">
            <h2 className="font-semibold text-slate-800 text-sm" data-id="element-228">
              অনুমোদনের জন্য প্রস্তুত ({readySubmissions.length})
            </h2>
          </div>
          <div className="divide-y divide-slate-100 max-h-[600px] overflow-y-auto" data-id="element-229">
            {readySubmissions.map(sub => <div key={sub.id} onClick={() => setSelectedSub(sub)} className={`p-4 cursor-pointer transition-colors ${selectedSub.id === sub.id ? 'bg-indigo-50 border-l-4 border-indigo-600' : 'hover:bg-slate-50 border-l-4 border-transparent'}`} data-id="element-230">
                <div className="flex justify-between items-start mb-1" data-id="element-231">
                  <span className="font-semibold text-slate-900 text-sm" data-id="element-232">
                    {sub.mouja}
                  </span>
                  <span className="text-xs font-medium text-slate-500" data-id="element-233">
                    {sub.id}
                  </span>
                </div>
                <p className="text-xs text-slate-600 mb-2" data-id="element-234">
                  {sub.upazila}, {sub.district}
                </p>
                <div className="flex justify-between items-center" data-id="element-235">
                  <span className="text-xs font-medium bg-slate-100 px-2 py-1 rounded text-slate-700" data-id="element-236">
                    {sub.khatianCount} খতিয়ান
                  </span>
                  <span className="text-xs text-slate-500" data-id="element-237">
                    {new Date(sub.submittedAt).toLocaleDateString('bn-BD')}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Detail View */}
      <div className="w-full lg:w-2/3 flex flex-col gap-4" data-id="element-238">
        <div className="card p-6" data-id="element-239">
          <div className="flex justify-between items-start mb-6" data-id="element-240">
            <div data-id="element-241">
              <h2 className="text-xl font-bold text-slate-900 mb-1" data-id="element-242">
                {selectedSub.mouja} মৌজা ডেটা
              </h2>
              <p className="text-sm text-slate-500" data-id="element-243">
                আইডি: {selectedSub.id} • দাখিল করেছেন {selectedSub.submittedBy}
              </p>
            </div>
            <StatusBadge status={selectedSub.status} data-id="element-244" />
          </div>

          <WorkflowProgress currentStatus={selectedSub.status} data-id="element-245" />
        </div>

        <div className="card flex-1 flex flex-col" data-id="element-246">
          <div className="flex border-b border-slate-200" data-id="element-247">
            <button className={`px-6 py-3 text-sm font-medium border-b-2 ${activeTab === 'summary' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} onClick={() => setActiveTab('summary')} data-id="element-248">
              সারসংক্ষেপ এবং পদক্ষেপ
            </button>
            <button className={`px-6 py-3 text-sm font-medium border-b-2 ${activeTab === 'khatians' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} onClick={() => setActiveTab('khatians')} data-id="element-249">
              ডেটা প্রিভিউ
            </button>
            <button className={`px-6 py-3 text-sm font-medium border-b-2 ${activeTab === 'documents' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} onClick={() => setActiveTab('documents')} data-id="element-250">
              নথিপত্র
            </button>
          </div>

          <div className="p-6 flex-1 overflow-y-auto" data-id="element-251">
            {activeTab === 'summary' && <div className="space-y-6" data-id="element-252">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-253">
                  <div className="bg-slate-50 p-4 rounded-md border border-slate-100" data-id="element-254">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-255">জেলা</p>
                    <p className="font-semibold text-slate-900" data-id="element-256">
                      {selectedSub.district}
                    </p>
                  </div>
                  <div className="bg-slate-50 p-4 rounded-md border border-slate-100" data-id="element-257">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-258">উপজেলা</p>
                    <p className="font-semibold text-slate-900" data-id="element-259">
                      {selectedSub.upazila}
                    </p>
                  </div>
                  <div className="bg-slate-50 p-4 rounded-md border border-slate-100" data-id="element-260">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-261">জেএল নম্বর</p>
                    <p className="font-semibold text-slate-900" data-id="element-262">
                      {selectedSub.jlNumber}
                    </p>
                  </div>
                  <div className="bg-slate-50 p-4 rounded-md border border-slate-100" data-id="element-263">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-264">মোট রেকর্ড</p>
                    <p className="font-semibold text-slate-900" data-id="element-265">
                      {selectedSub.khatianCount}
                    </p>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-md p-4 flex items-start" data-id="element-266">
                  <ShieldCheck className="text-blue-600 mt-0.5 mr-3 flex-shrink-0" size={20} data-id="element-267" />
                  <div data-id="element-268">
                    <h4 className="text-sm font-semibold text-blue-900" data-id="element-269">
                      সিস্টেম যাচাইকরণ সফল
                    </h4>
                    <p className="text-xs text-blue-800 mt-1" data-id="element-270">
                      ডেটা সফলভাবে ইউনিকোডে রূপান্তরিত হয়েছে, স্যানিটাইজ করা
                      হয়েছে এবং ডিএলআরএস স্কিমায় ম্যাপ করা হয়েছে। ক্রস-চেক
                      করার সময় কোন অসঙ্গতি পাওয়া যায়নি।
                    </p>
                  </div>
                </div>

                <div className="border-t border-slate-200 pt-6" data-id="element-271">
                  <h3 className="text-sm font-semibold text-slate-800 mb-3 uppercase tracking-wider" data-id="element-272">
                    চূড়ান্ত সিদ্ধান্ত
                  </h3>
                  <textarea className="input-field mb-4 text-sm" rows={3} placeholder="অনুমোদনের মন্তব্য বা প্রত্যাখ্যানের কারণ যোগ করুন..." data-id="element-273"></textarea>
                  <div className="flex space-x-4" data-id="element-274">
                    <button className="btn-success flex-1 py-3 flex justify-center items-center font-semibold text-base shadow-sm" data-id="element-275">
                      <CheckCircle size={20} className="mr-2" data-id="element-276" /> অনুমোদন এবং
                      ডিএলএমএস-এ প্রকাশ করুন
                    </button>
                    <button className="btn-danger px-6 py-3 flex justify-center items-center font-semibold shadow-sm" data-id="element-277">
                      <XCircle size={20} className="mr-2" data-id="element-278" /> প্রত্যাখ্যান করুন
                    </button>
                  </div>
                </div>
              </div>}

            {activeTab === 'khatians' && <div data-id="element-279">
                <div className="flex justify-between items-center mb-4" data-id="element-280">
                  <h3 className="font-semibold text-slate-800" data-id="element-281">
                    প্রথম ৫টি রেকর্ডের প্রিভিউ
                  </h3>
                  <button className="text-sm text-indigo-600 font-medium flex items-center hover:underline" data-id="element-282">
                    <Download size={16} className="mr-1" data-id="element-283" /> সম্পূর্ণ সিএসভি
                    ডাউনলোড করুন
                  </button>
                </div>
                <div className="overflow-x-auto border border-slate-200 rounded-md" data-id="element-284">
                  <table className="min-w-full divide-y divide-slate-200" data-id="element-285">
                    <thead className="bg-slate-50" data-id="element-286">
                      <tr data-id="element-287">
                        <th className="px-4 py-2 text-left text-xs font-medium text-slate-500" data-id="element-288">
                          খতিয়ান নং
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-slate-500" data-id="element-289">
                          মালিকের নাম
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-slate-500" data-id="element-290">
                          পিতার নাম
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-slate-500" data-id="element-291">
                          জমির পরিমাণ
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200" data-id="element-292">
                      {[1, 2, 3, 4, 5].map(i => <tr key={i} data-id="element-293">
                          <td className="px-4 py-2 text-sm text-slate-900" data-id="element-294">
                            {44 + i}
                          </td>
                          <td className="px-4 py-2 text-sm text-slate-900 font-bengali" data-id="element-295">
                            জালাল উদ্দিন
                          </td>
                          <td className="px-4 py-2 text-sm text-slate-500 font-bengali" data-id="element-296">
                            সিরাজ উদ্দিন
                          </td>
                          <td className="px-4 py-2 text-sm text-slate-500" data-id="element-297">
                            ২.৫০ একর
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>}

            {activeTab === 'documents' && <div className="grid grid-cols-2 gap-6 h-full" data-id="element-298">
                <div className="border border-slate-200 rounded-md flex flex-col" data-id="element-299">
                  <div className="bg-slate-50 px-3 py-2 border-b border-slate-200 font-medium text-sm text-slate-700 flex justify-between items-center" data-id="element-300">
                    গেজেট কপি/কেস কপি
                    <Download size={14} className="text-slate-400 cursor-pointer hover:text-slate-700" data-id="element-301" />
                  </div>
                  <div className="flex-1 bg-slate-200 flex items-center justify-center min-h-[300px]" data-id="element-302">
                    <FileText size={48} className="text-slate-400" data-id="element-303" />
                    <span className="ml-2 text-slate-500 font-medium" data-id="element-304">
                      পিডিএফ প্রিভিউ
                    </span>
                  </div>
                </div>
                <div className="border border-slate-200 rounded-md flex flex-col" data-id="element-305">
                  <div className="bg-slate-50 px-3 py-2 border-b border-slate-200 font-medium text-sm text-slate-700 flex justify-between items-center" data-id="element-306">
                    হস্তান্তর পত্র/সংশোধন পত্র
                    <Download size={14} className="text-slate-400 cursor-pointer hover:text-slate-700" data-id="element-307" />
                  </div>
                  <div className="flex-1 bg-slate-200 flex items-center justify-center min-h-[300px]" data-id="element-308">
                    <FileText size={48} className="text-slate-400" data-id="element-309" />
                    <span className="ml-2 text-slate-500 font-medium" data-id="element-310">
                      পিডিএফ প্রিভিউ
                    </span>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};